{
  "curates": "Kuratiert: {{kinds}}",
  "forEmail": "Für {{email}}",
  "join": "Sie kommen in {{groups}}",
  "may": "Sie dürfen: {{permissions}}",
  "notPending": {
    "accepted": "Diese Einladung wurde schon angenommen. Melden Sie sich stattdessen an.",
    "expired": "Diese Einladung ist abgelaufen. Bitten Sie die einladende Person um eine neue.",
    "revoked": "Diese Einladung wurde zurückgezogen. Bitten Sie die einladende Person um eine neue."
  },
  "offer": "{{name}} hat Sie zu DMW eingeladen.",
  "offerProject": "{{name}} hat Sie zu {{project}} eingeladen.",
  "ready": "Ihr Konto ist bereit. Melden Sie sich an.",
  "submit": "Konto anlegen",
  "title": "Einladung annehmen",
  "token": "Einladungs-Token"
}
